import { type ReactNode } from 'react';
import { Button } from 'src/components/Button';
import { ButtonPropsWithLabel } from 'src/components/Dialog';
import { Stack } from 'src/components/Stack';

export function ActionsList({
  actions,
}: {
  actions: ReactNode | ButtonPropsWithLabel[];
}) {
  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      justifyContent="flex-end"
      sx={{ width: '100%' }}
    >
      {Array.isArray(actions) &&
        actions.map((buttonProps, i) => (
          <Button key={buttonProps.label?.toString() ?? i} {...buttonProps}>
            {buttonProps.children || buttonProps.label}
          </Button>
        ))}
      {!Array.isArray(actions) && actions}
    </Stack>
  );
}
